import { Constants } from "appConstants";
import { IcoClose } from "assets/icons";
import Button from "components/Button";
import "./styles.scss";

interface ConfirmationModalProps {
	show: boolean;
	onCancel: () => void;
	onProceed: () => void;
}

export default function ConfirmationModal({
	show,
	onCancel,
	onProceed
}: ConfirmationModalProps) {
	if (!show) {
		return null;
	}

	return (
		<div className="confirmation-modal">
			<div className="overlay">
				<div className="content">
					<div className="flex items-center gap-6 self-stretch justify-between">
						<h2 className="font-semibold text-base">
							{Constants.strings.pages.term.modalTitle}
						</h2>
						<div className="cursor-pointer" onClick={onCancel}>
							<IcoClose size="16" />
						</div>
					</div>
					<p className="text-sm font-normal leading-6">
						{Constants.strings.pages.term.warningMessage}
					</p>
					<div className="flex justify-end items-center gap-4 self-stretch text-base font-semibold">
						<Button styled="ghost" kind="link" onClick={onCancel}>
							{Constants.strings.inputs.cancel}
						</Button>
						<Button styled="primary" onClick={onProceed}>
							{Constants.strings.inputs.exclude}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
